import { useEffect, useState } from 'react';
import { fetchMediaFileBlob } from '../../../app/api';

export function useMediaImageSrc(mediaId) {
  const [src, setSrc] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!mediaId) {
      setSrc('');
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    let objectUrl = '';

    setLoading(true);
    setError(null);
    setSrc('');

    fetchMediaFileBlob(mediaId)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
        setLoading(false);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e);
        setLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [mediaId]);

  return { src, loading, error };
}

export async function createMediaImageObjectUrl(mediaId) {
  const blob = await fetchMediaFileBlob(mediaId);
  return URL.createObjectURL(blob);
}

export function revokeMediaImageObjectUrls(urls) {
  (urls || []).forEach((url) => {
    if (url) {
      URL.revokeObjectURL(url);
    }
  });
}
